/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Tab_RecoveryInputs */

const en_client_tab_recovery = /** @type {(inputs: Client_Tab_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery`)
};

const pl_client_tab_recovery = /** @type {(inputs: Client_Tab_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeneracja`)
};

/**
* | output |
* | --- |
* | "Recovery" |
*
* @param {Client_Tab_RecoveryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const client_tab_recovery = /** @type {((inputs?: Client_Tab_RecoveryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Tab_RecoveryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_client_tab_recovery(inputs)
	return en_client_tab_recovery(inputs)
});